const logosAjax = () => {
  const wrapper = document.querySelector(".js-logos-more");
  if (!wrapper) {
    return;
  }

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("js-logos-btn")) {
      e.preventDefault();
      let page = e.target.getAttribute("data-page");
      let index = e.target.getAttribute("data-index");
      let total = e.target.getAttribute("data-total");
      e.target.classList.add("hidden");

      fetchData(page, index);
      e.target.setAttribute("data-index", parseInt(index) + 1);
    }
  });

  async function fetchData(page, index) {
    let formData = new FormData();
    formData.append("action", "logos_ajax");
    formData.append("page", page);
    formData.append("index", index);
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    wrapper.innerHTML = data.files;
  }
};

export default logosAjax;
